import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from '#pplx/frontend/aether/components/ConfirmationModal/index.js';
import { MenuItem } from '#pplx/frontend/aether/components/internal/menu/MenuItem.js';
import { ModalContext } from '#pplx/frontend/aether/modals/context/ModalContext.js';
import { useCallback, useContext, useId } from 'react';
export function MenuDestructiveItem({ onConfirm, confirmation, ...props }) {
    const modalContext = useContext(ModalContext);
    const descriptionId = useId();
    const handleSelect = useCallback(() => {
        if (!confirmation) {
            onConfirm();
            return;
        }
        if (!modalContext) {
            throw new Error('Menu.DestructiveItem with `confirmation` requires a ModalProvider in the tree.');
        }
        modalContext.openModal(ConfirmationModal, {
            title: confirmation.title,
            body: typeof confirmation.bodyText === 'string' ? (confirmation.bodyText) : (_jsx("div", { id: descriptionId, className: "contents", children: confirmation.bodyText })),
            'aria-describedby': typeof confirmation.bodyText === 'string' ? undefined : descriptionId,
            confirmLabel: confirmation.confirmButtonTitle,
            intent: 'warning',
            onConfirm,
        }, { replace: false });
    }, [confirmation, descriptionId, modalContext, onConfirm]);
    return _jsx(MenuItem, { ...props, variant: "negative", onSelect: handleSelect });
}
//# sourceMappingURL=MenuDestructiveItem.js.map